<template>
    <div id="all-content">
        <div class="row padding-top">
            <div class="col-xl-6 col-lg-4 pt-2 pb-2 big-screen">
                <div id="calendar-filters" class="row col-xl-12 mt-1" style="display:block">
                    <div class="custom-control custom-switch custom-switch-lg selection-off pl-0">
                        <div class="card-title float-left">Afdelingen</div>
                        <input type="checkbox" class="custom-control-input" id="filtersCB">
                        <label class="custom-control-label ml-5" id="filtersCB_label" for="filtersCB"></label>
                    </div>
                </div>
            </div>
            <div class="col-6 pt-3 pb-2 text-center small-screen" id="filter-options">
                <div class="card-title m-0" id="filter-department-text">Afdelingen <i class="fas fa-filter"></i></div>
            </div>
            <div class="col-6 pt-3 pb-2 text-center small-screen">
                <button type="button" class="today btn btn-outline-light text-dark" @click="today()">
                    Vandaag
                </button>
            </div>
            <div class="col-xl-4 col-lg-5 col-12 p-2 big-screen">
                <div class="row selection-off">
                    <div class="col-xl-3 col-lg-4 text-center today" @click="today()">
                        Vandaag
                    </div>
                    <div class="col-xl-1 col-lg-1 col-1 text-right">
                        <i class="fas fa-chevron-left month-chrevron" @click="previousView()"></i>
                    </div>
                    <div class="month-name col-xl-6 col-lg-6 col-10 text-center p-0">
                        {{ currentHeaderText }}
                        <input id="weeks" type="hidden" :value="weeks.length" />
                    </div>
                    <div class="col-xl-1 col-lg-1 col-1 text-left">
                        <i class="fas fa-chevron-right month-chrevron" @click="nextView()"></i>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 pb-2 big-screen">
                <select id="viewType" @change="changeView($event)" class="form-control custom-select">
                    <option selected value="0">Maand</option>
                    <option value="1">Week</option>
                </select>
            </div>
        </div>
        <div class="row mb-3">
            <calendar-filters v-on:change-filter="changeFilter"></calendar-filters>
            <div id="overview-users" class="col-xl-2 col-lg-3 border rounded-left text-white pt-3 pb-3 big-screen" style="background-color: #5933C6; height: 520px;">
                <div class="row" style="height: 88px;">
                    <div class="col-12 pl-0">
                        <h5 class="col-11 offset-1">Overzicht</h5>
                    </div>
                    <div class="col-12 mb-4 pl-0">
                        <h4 class="col-11 offset-1 font-weight-bold">{{ company_name }}</h4>
                    </div>
                </div>
                <div class="row" id="all-users" style="height: 392px; overflow-y: auto;">
                    <div class="pt-2" style="min-height: 392px; width: 95%;">
                        <div class="col-xl-12 mt-2" style="height: 40px;" v-for="(data) in users" v-bind:key="data.employee_id">
                            <h6 class="col-11 offset-1 pl-0 hide-text" style="top: 10px; width: 96%;">{{ data.fullName }}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div id="calendar-object" class="col-xl-10 col-lg-9 col-12 rounded-right card card-body pt-3" style="overflow:auto; height: 520px; width: 100%;">
                <div id="calendar-header" class="row" style="height: 90px; min-width: 210px;">
                    <div class="col mr-1 ml-1" style="position: relative;" v-for="(week) in calendarWeeks" v-bind:key="week.number">
                        <div class="row text-center">
                            <div class="offset-2 col-1 text-right text-primary small-screen">
                                <i class="fas fa-chevron-left month-chrevron" @click="previousView()"></i>
                            </div>
                            <div class="col-6 col-xl-12 col-lg-12 text-primary">
                                <h5>
                                    Week {{ week.number }}
                                </h5>
                            </div>
                            <div class="col-2 text-left text-primary small-screen">
                                <i class="fas fa-chevron-right month-chrevron" @click="nextView()"></i>
                            </div>
                        </div>
                        <div class="row text-center mb-1">
                            <div class="m-auto" v-for="(day, index) in week.days" v-bind:key="index">
                                <small class="text-muted" v-if="day != null">{{ day.text }}</small><br />
                                <span v-if="day != null  && (currentWeek != week.number || day.date != currentDay)">{{ day.date }}</span>
                                <span v-else-if="day != null  && day.date == currentDay && currentWeek == week.number" class="dot pt-1">{{ day.date }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="calendar-content" class="row pt-2" style="overflow-y: auto; overflow-x: auto; height: 398px;">
                    <div class="col mr-1 ml-1" style="position: relative; min-height: 308px; width: 25%" v-for="(week, weekIndex) in calendarWeeks" v-bind:key="week.number">
                        <div v-for="(data, index) in users" v-bind:key="index" class="row text-center mt-2" :class="'week-' + week.number">
                            <div class='col-12 text-left text-primary mb-1 small-screen'>
                                <span>{{ data.fullName }}</span> <br />
                            </div>
                            <div v-for="i in 7" v-bind:key="i" class="m-auto" style="width: 13%; height: 40px; position: relative;" :style="(i == 6 || i == 7) ? 'background-color: #b3b3b3;' : 'background-color: #d9d9d9;'">
                                <!-- Calendar grey blocks (days) -->
                                <i class="mt-2" :class="getIcon(week.days[i - 1])"></i>
                            </div>

                            <div v-bind:key="absence.range_id" v-for='(absence) in absences'>
                                <calendar-absence-object v-if="checkDateWeek(absence, week.number, weekIndex, data.lastUsedProfileId)" v-on:popup-open="openPopup"
                                :absence="absence"
                                :viewType="viewType"
                                :weekNumber="week.number"
                                :weeks="weeks"
                                :widthWeek="weekLength(week.number)"
                                :currentMonthYear="currentMonthYear"
                                :employer="employer"
                                :current_profile_id="current_profile_id"
                                ></calendar-absence-object>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <calendar-popup v-if="currentAbsence !== null" v-on:close="closePopups" v-on:warningNotCharged="warningNotCharged" v-on:warningStatus="warningStatus"
                :absence="currentAbsence"
                :viewType="viewType"
                :currentMonthYear="currentMonthYear"
                :weeks="weeks"
                :employer="employer"
            ></calendar-popup>
            <calendar-warning-popup
                :absence="currentAbsence"
                :value="valueChangeTo"
                :oldValue="oldValue"
                :employer="employer"
                v-on:changeStatus="changeStatus"
                v-on:cancelStatus="cancelStatus"
                v-on:changeNotCharged="changeNotCharged"
                v-on:cancelNotCharged="cancelNotCharged"
                :type="warningType"
            ></calendar-warning-popup>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-xl-3 col-lg-5">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title">Legenda</div>
                                <ul id="legenda" class="offset-4 mt-2">
                                    <li style="line-height: 0.7;"><span>Ingediend</span></li>
                                    <li style="line-height: 0.7;"><span>Goedgekeurd</span></li>
                                    <li style="line-height: 0.7;"><span>Afgekeurd</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-7">
                        <div class="row pt-2" style="height: 72px;">
                            <div class="offset-xl-9 col-xl-1 offset-lg-5 col-lg-3 offset-1 col-4">
                                <span class="print h5" @click="printPDF()"><i class="fas fa-print text-secondary"></i> Print</span>
                            </div>
                            <div class="col-xl-2 col-lg-4 col-7">
                                <span class="download h5" @click="downloadPDF()"><i class="fas fa-download text-secondary"></i> Download PDF</span>
                            </div>
                        </div>
                        <div v-if="!employer" class="row col-12 p-0 m-0">
                            <div class="card">
                                <div class="card-body">
                                    <div class="card-title">Zelf verlof aanvragen?</div>
                                    <p>Wil je zelf verlof aanvragen? Maak het gemakkelijk met onze handige online verlofaanvraag. Klik op "Verlof aanvragen" hieronder om direct naar het aanvraagformulier te gaan.</p>
                                    <a class="btn btn-secondary btn-sm" href="/employee/absences/create">Verlof aanvragen</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import momentEaster from 'moment-easter';
    import jsPDF from "jspdf";
    import html2canvas from 'html2canvas'

    export default {
        components: {
            moment,
        },
        props: {
            company_name: String,
            usersset: Array,
            employer: Boolean,
            current_profile_id: Number,
            holidays: Array,
        },
        data: function () {
            return {
                calendarWeeks: [],
                weeks: [],
                absences: [],
                currentMonthYear: moment().locale('nl').format("YYYY-MM"),
                currentHeaderText: moment().locale('nl').format("MMMM (YYYY)"),
                ids: [],
                startDate: null,
                endDate: null,
                viewType: 0,
                type: "months",
                currentWeek: moment().locale('nl').week(),
                currentAbsence: null,
                users: [],
                valueChangeTo: null,
                oldValue: null,
                warningType: false,
                calendar_width: "",
                windowWidth: window.innerWidth,
                currentDay: moment().locale('nl').format('D'),
                defaultHolidayIcons: {
                    "27-04": 'fas fa-crown text-secondary',
                    "25-12": 'fas fa-gift text-danger',
                    "26-12": 'fas fa-gift text-danger',
                    "01-01": 'fas fa-glass-cheers',
                    "05-05": 'fas fa-dove text-primary',
                },
                holidayIcons : {}
            }
        },
        beforeMount() {
            window.addEventListener('resize', this.screenSize);
            this.screenSize();

            this.users = this.usersset;
            this.calendar_width = (this.windowWidth >= 1140) ? "" : "width: 800px;";

            this.mount();
            this.getAbsences();
        },
        methods: {
            screenSize() {
                if (window.innerWidth < 960 && this.viewType == 0) {
                    this.currentMonthYear = moment().locale('nl').format("YYYY-MM-DD");
                    this.viewType = 1;
                    this.type = "weeks";
                    this.setHeaderText();
                    this.mount();
                } else if (window.innerWidth >= 960 && this.viewType == 1) {
                    this.viewType = 0;
                    this.type = 'months';
                    this.currentMonthYear = moment().locale('nl').format("YYYY-MM-DD");
                    this.setHeaderText();
                    this.mount();
                }

            },
            mount() {
                this.calculateHolidays();
                // Setting data that probably will be chosen by user on page it self
                let format = "Y-MM";
                let start = "-01"
                if (this.viewType == 1) {
                    format = "Y-MM-DD";
                    start = "";
                }

                let chosenTimeView = moment(this.currentMonthYear).format(format);
                if (this.viewType == 1) {
                    this.currentWeek = moment().locale('nl').week();
                }

                // Start week of the selected month
                this.startDate = moment(chosenTimeView + start).locale('nl');

                // Dates of all weeks
                this.buildHeader();
            },
            /**
             *
             * Getting all absences
             *
             */
            getAbsences() {
                // All user ids
                this.ids = [];
                this.users.forEach(data => this.ids.push(data.lastUsedProfileId));

                // Removing all current absences
                this.absences = [];

                // AJAX call with getting the absences of all shown users
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/absences`,
                    data:{
                        ids: this.ids,
                        start: this.startDate.clone().locale('nl').startOf("isoWeek").format("Y-MM-DD"),
                        end: this.startDate.clone().locale('nl').endOf(this.type).endOf("isoWeek").format('Y-MM-DD'),
                    },
                    success: this.addingAbsences,
                });
            },
            /**
             *
             * Building the header of the calendar
             *
             */
            buildHeader() {
                let date = this.startDate.clone();

                // Empty all arrays for new build
                let days = [];
                this.calendarWeeks = [];
                this.weeks = [];

                // Start settings for while-loop
                let currentMonth = date.format("M");
                let startWeekNumber = date.week();
                let iteration = true;

                // Keep iterating while it's allowed
                while (iteration) {
                    // Iterating through all days of week
                    // Does already do +1 day everytime it iterates
                    for (let i = 1; i <= 7; i++) {
                        let day = date.isoWeekday(i).format("D");
                        let formattedDate = date.isoWeekday(i).format("Y-MM-DD");

                        let dayName = moment(formattedDate).locale('nl').format('dd');
                        if (this.viewType == 1 && this.windowWidth >= 960) {
                            dayName = moment(formattedDate).locale('nl').format('dddd');
                        }

                        // Saving day to days of week
                        days.push({
                            date: day,
                            text: dayName,
                            full_date: formattedDate,
                        });
                    }

                    // Adding week to calendar
                    this.calendarWeeks.push({
                        days: days,
                        number: date.week()
                    });

                    // Saving week numbers
                    this.weeks.push(date.week());

                    // If month isn't the same and the week also differs from starting week it will stop iterating
                    if ((moment(date).format("M") != currentMonth && date.week() != startWeekNumber) || (this.viewType == 1 && date.week() == startWeekNumber)) {
                        iteration = false;
                        this.endDate = date;
                    }

                    // Emptying days for next week
                    days = [];
                    date.add(1, "days");
                }
            },
            /**
             *
             * Button Actions
             *
             */
            nextView() {
                this.currentMonthYear = moment(this.currentMonthYear).locale('nl').startOf(String(this.type).slice(0, -1)).add(1, this.type).format("YYYY-MM-DD");
                this.setHeaderText();
                this.rebuildCalendar();
                this.calculateHolidays();
            },
            previousView() {
                this.currentMonthYear = moment(this.currentMonthYear).locale('nl').startOf(String(this.type).slice(0, -1)).subtract(1, this.type).format("YYYY-MM-DD");
                this.setHeaderText();
                this.rebuildCalendar();
                this.calculateHolidays();
            },
            rebuildCalendar() {
                this.mount();
                this.getAbsences();
            },
            today() {
                this.currentMonthYear = moment().locale('nl').format("YYYY-MM-DD");

                this.setHeaderText();
                this.rebuildCalendar();
            },
            changeView(event) {
                this.viewType = Number(event.target.value);

                if (this.viewType == 1) {
                    this.type = "weeks";
                } else  {
                    this.type = 'months';
                }

                this.setHeaderText();
                this.rebuildCalendar();
            },
            setHeaderText() {
                if (this.viewType == 0) {
                    this.currentHeaderText = moment(this.currentMonthYear).locale('nl').format("MMMM (YYYY)");
                } else if(this.viewType == 1) {
                    this.currentHeaderText = `Week ${moment(this.currentMonthYear).locale('nl').week()} (${moment(this.currentMonthYear).locale('nl').format("MMMM")}, ${moment(this.currentMonthYear).locale('nl').format("YYYY")})`;
                }
            },
            /**
             *
             * Events
             *
             */
            closePopups() {
                this.currentAbsence = null;
            },
            warningStatus(status, absence_id) {
                this.valueChangeTo = status;
                let warning = false

                // Check if current absence has connected ranges
                if (this.currentAbsence.connected_ranges) {
                    $('#warning_popup').modal('show');
                    warning = true;
                    this.warningType = false;
                    this.oldValue = this.currentAbsence.status;
                    this.currentAbsence.status = status;
                }

                if (!warning) this.changeStatus(status, absence_id);
            },
            cancelStatus(oldValue) {
                // Reset to old value
                if (this.currentAbsence.connected_ranges) {
                    this.currentAbsence.status = oldValue;
                    $('#warning_popup').modal('hide');
                }
            },
            changeStatus(status, id) {
                // Set all connected absences to correct value
                this.absences.forEach((absence) => {
                    if (absence.absence_id == id) absence.status = status;
                });

                // Save the new values
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/status`,
                    data:{
                        id: id,
                        status: status,
                    },
                });
            },
            warningNotCharged(notCharged, absence_id) {
                this.valueChangeTo = notCharged;
                let warning = false

                // Check if current absence has connected ranges
               if (this.currentAbsence.connected_ranges) {
                    $('#warning_popup').modal('show');
                    warning = true;
                    this.warningType = true;
                    this.oldValue = this.currentAbsence.notcharged;
                    this.currentAbsence.notcharged = notCharged;
                }

                if (!warning) this.changeNotCharged(notCharged, absence_id);
            },
            cancelNotCharged(oldValue) {
                // Reset to old value
                if (this.currentAbsence.connected_ranges) {
                    this.currentAbsence.notcharged = oldValue;
                    $('#warning_popup').modal('hide');
                }
            },
            changeNotCharged(notCharged, id) {
                // Set all connected absences to correct value
                this.absences.forEach((absence ) => {
                    if (absence.absence_id == id) {
                        absence.notcharged = notCharged;
                    }
                });

                // Save the new values
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/not-charging`,
                    data:{
                        id: id,
                        notCharged: notCharged,
                    },
                });
            },
            openPopup(absence) {
                this.currentAbsence = (this.employer || this.current_profile_id == absence.profile_id) ? absence : this.currentAbsence;
            },
            changeFilter(filterID) {
                // Get data of currently selected filter
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/set-filter`,
                    data:{
                        id: filterID,
                    },
                    success: this.changeShownUsers,
                });
            },
            /**
             *
             * Callbacks
             *
             */
            changeShownUsers(event) {
                this.users = event.users;
            },
            addingAbsences(absences) {
                this.absences = absences;
            },
            /**
             *
             * Checks / info
             *
             */
            weekLength(week) {
                return $('.week-' + week).width();
            },
            checkDateWeek(absence, weekNumber, index, id) {
                return ((moment(absence.start_date).locale('nl').week() == weekNumber && absence.profile_id == id) || ((absence.view_type == 2 || absence.view_type == 1) && absence.profile_id == id && index == 0));
            },
            getIcon(weekDay) {
                for (const [key, value] of Object.entries(this.holidayIcons)) {
                    if (key == moment(weekDay.full_date, "Y-MM-DD").locale('nl').format("DD-MM")) {
                        return value;
                    }
                }
            },
            calculateHolidays() {
                let easterDate = momentEaster.easter(moment(this.currentMonthYear).format("Y")).format('Y-MM-DD');
                this.holidayIcons = { ...this.defaultHolidayIcons } ;

                for (const [key, value] of Object.entries(this.holidays)) {
                    switch (value.type) {
                        case 1:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').format('DD-MM')] = "fas fa-egg";
                            break;
                        case 2:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').add(1, 'day').format('DD-MM')] = "fas fa-egg";
                            break;
                        case 3:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').subtract(2, 'days').format('DD-MM')] = "fas fa-cross";
                            break;
                        case 4:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').add(39, 'days').format('DD-MM')] = "fas fa-menorah";
                            break;
                        case 5:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').add(49, 'days').format('DD-MM')] = "fas fa-bible";
                            break;
                        case 6:
                            this.holidayIcons[moment(easterDate, 'Y-MM-DD').add(50, 'days').format('DD-MM')] = "fas fa-bible";
                            break;
                    }
                }
            },
            /**
             *
             * Sorting
             *
             */
            compare(value1, value2) {
                if (value1.text < value2.text){
                    return -1;
                }
                if (value1.text > value2.text){
                    return 1;
                }
                return 0;
            },
            /**
             *
             * Print & download PDF
             *
             */
            downloadPDF() {
                var pdf = new jsPDF('l', 'px', 'a1');
                var element = document.getElementById('all-content');

                html2canvas(element, {
                    onclone: function (clonedEl) {
                        clonedEl.getElementById('overview-users').style.height = '';
                        clonedEl.getElementById('all-users').style.height = '';
                        clonedEl.getElementById('calendar-object').style.height = '';
                        clonedEl.getElementById('calendar-content').style.height = '';
                    }
                }).then(canvas => {
                    var image = canvas.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(image, 'JPEG', 10, 0, 1741, 893);
                    pdf.save('agenda.pdf');
                });
            },
            printPDF() {
                var element = document.getElementById('all-content');
                var win = window.open('');

                html2canvas(element, {
                    onclone: function (clonedEl) {
                        clonedEl.getElementById('overview-users').style.height = '';
                        clonedEl.getElementById('all-users').style.height = '';
                        clonedEl.getElementById('calendar-object').style.height = '';
                        clonedEl.getElementById('calendar-content').style.height = '';
                    }
                }).then(canvas => {
                    var image = canvas.toDataURL('image/jpeg', 1.0);

                    var img = win.document.createElement("img");
                    img.src = image;
                    img.width = '1500';

                    win.document.body.appendChild(img);

                    img.onload = function() {
                        win.print();
                        win.close();
                    };
                });
            }
        },
    }
</script>
